export const getFormMethod = (submitAction) => {
    return typeof submitAction === 'string' ? { method: 'POST' } : {};
};
//# sourceMappingURL=getFormMethod.js.map